import { render } from "./VendorsShowTabs.vue?vue&type=template&id=03e5bd6f"
import script from "./VendorsShowTabs.vue?vue&type=script&lang=js"
export * from "./VendorsShowTabs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__